import type { IResultstash, JsonQuery } from "@mne-core/api";
import { QueryController, createGetRequestOpts, createUrl, fetchJsonQuery } from "@mne-core/api";

import type { IOauthClient } from "../@types";

export interface IFetchOauthClientsParams {
  customer?: Array<string>;
  domain?: Array<string>;
  excludeFlags?: Array<"hidden">;
  keywords?: Array<string>;
  limit?: number;
  offset?: number;
  sortBy?: Array<string>;
}

export interface IFetchOauthClientsOpts {
  apiUrl: string;
  apikey?: string;
  ctrl?: QueryController;
  sessionKey?: string;
}

export const createRequest = (queryParams: IFetchOauthClientsParams, opts: IFetchOauthClientsOpts): Request => {
  const { apiUrl } = opts;
  const uri = createUrl(apiUrl, ["authentication", "v1", "oauth", "client"], queryParams).toString();
  return new Request(uri, createGetRequestOpts(opts));
};

async function fetchOauthClients(
  queryParams: IFetchOauthClientsParams,
  opts: IFetchOauthClientsOpts,
): Promise<JsonQuery<IResultstash<Array<IOauthClient>>>> {
  return await fetchJsonQuery<IResultstash<Array<IOauthClient>>>(createRequest(queryParams, opts), {
    ctrl: opts.ctrl || new QueryController(),
  });
}

export default fetchOauthClients;
